const InfoIconOverride = ({ size = 20, color = "#8a8a8a" }: { size?: number | string; color?: string }) => {
    return (
        <svg viewBox="1 1 18 18" width={size} height={"100%"} focusable="false" aria-hidden="true" fill={color}>
            <path d="M10 14a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-.75.75Z"></path>
            <path d="M9 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"></path>
            <path
                fillRule="evenodd"
                d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
            ></path>
        </svg>
    );
};

export default InfoIconOverride;
